// 代销业务-状态字典
// 与后端枚举对齐: MatchStatusEnum / SettleStatusEnum / ContractStatusEnum / ContractTypeEnum

// 匹配状态: 0 未匹配 1 已匹配 2 部分匹配
export const matchStatusConfig = {
    '0': { color: '#595959', label: '未匹配', show: true },
    '1': { color: 'green',   label: '已匹配', show: true },
    '2': { color: 'orange',  label: '部分匹配', show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// 清算状态: 0 未清算 1 已清算 2 部分清算 9 清算失败
export const settleStatusConfig = {
    '0': { color: '#595959', label: '未清算', show: true },
    '1': { color: 'green',   label: '已清算', show: true },
    '2': { color: 'orange',  label: '部分清算', show: true },
    '9': { color: 'red',     label: '清算失败', show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// 合同状态: 0 草稿 1 待审批 2 审批通过 3 审批拒绝 4 已作废
export const contractStatusConfig = {
    '0': { color: '#595959', label: '草稿',     show: true },
    '1': { color: 'blue',    label: '待审批',   show: true },
    '2': { color: 'green',   label: '审批通过', show: true },
    '3': { color: 'red',     label: '审批拒绝', show: true },
    '4': { color: 'grey',    label: '已作废',   show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// 合同类型: 11 分账协议 12 税筹协议 13 还款协议
export const contractTypeConfig = {
    '11': { color: '#4A90E2', label: '分账协议', show: true },
    '12': { color: '#34C759', label: '税筹协议', show: true },
    '13': { color: '#FF9500', label: '还款协议', show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// 原始结算单 - 汇总状态: 0 未汇总 1 已汇总 2 汇总失败
export const summaryStatusConfig = {
    '0': { color: '#595959', label: '未汇总', show: true },
    '1': { color: 'green',   label: '已汇总', show: true },
    '2': { color: 'red',     label: '汇总失败', show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// 汇总单 - 银行 310907 登记同步状态: 0 未同步 1 已同步 2 同步失败
// 与 SyncStatusEnum 对齐, 详见 V1.5__consign_summary_sync_status.sql
export const summarySyncStatusConfig = {
    '0': { color: '#595959', label: '未同步', show: true },
    '1': { color: 'green',   label: '已同步', show: true },
    '2': { color: 'red',     label: '同步失败', show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// 汇总单修正表 - 操作类型: 0 登记 1 重试同步
// 与 OperationTypeEnum 对齐
export const revisionOperationTypeConfig = {
    '0': { color: 'blue',  label: '登记',     show: true },
    '1': { color: 'purple', label: '重试同步', show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// 汇总单修正表 - 操作结果: 0 成功 1 失败
// 与 OperationResultEnum 对齐
export const revisionOperationResultConfig = {
    '0': { color: 'green', label: '成功', show: true },
    '1': { color: 'red',   label: '失败', show: true },
    default: { color: '#bfbfbf', label: '未知', show: false },
};

// map -> [{value,label,color}] 工具（下拉框 / select-option 用）
export const toOptions = (cfg) =>
    Object.keys(cfg)
        .filter(k => k !== 'default')
        .map(k => ({ value: k, label: cfg[k].label, color: cfg[k].color }));
